import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  ReferenceInput,
  AutocompleteInput,
  useTranslate,
  ReferenceArrayInput,
  SelectArrayInput, AutocompleteArrayInput,
    required,
    usePermissions,
    FormDataConsumer,
    useRedirect,
    useNotify,
    Toolbar,
    SaveButton,
    BooleanInput
} from 'react-admin';

import PhoneInput from '../common/PhoneInput';

import s from './Citizen.module.css';
import { checkBuildingManagement } from '../../raUtils/authProvider';
import { fetchCommunes, fetchVillages } from '../../api';
import { isDransgrid, isLiddes } from '../../raUtils/httpClient';
import { useFormContext } from 'react-hook-form';

export default function CitizenCreate(props: any) {
  const t = useTranslate();
  const redirect = useRedirect();
  const notify = useNotify();

  const { isLoading, permissions } = usePermissions();

  const [phoneNumber, setPhoneNumber] = useState('');

  const [village, setVillage] = useState<any>('');
  const [villages, setVillages] = useState<any[]>([]);
  const [filteredVillages, setFilteredVillages] = useState<any[]>([{id: -1, name: "Sélectionner une commune", disabled: true}]);

  const [communes, setCommunes] = useState<any[]>([]);
  const [commune, setCommune] = useState<any>('');

  useEffect(() => {
    fetchVillages().then((response) => {
      const responseVillages = response.data;
      setVillages(responseVillages);

      if(isLiddes()){
        const liddesVillages = responseVillages.filter((village) => village.commune.name === "Liddes");
        setFilteredVillages(liddesVillages);
      }
    })

    fetchCommunes().then((response) => {
        const responseCommunes = response.data;
        setCommunes(responseCommunes);
        if(isLiddes()){
          const liddes = responseCommunes.find((commune) => commune.name === "Liddes");
          setCommune(liddes.id);
        }
    })
  }, []);

  function filterVillageByCommuneId(id){
    const villagesFromCommune = villages.filter((village) => village.commune.id === id);
    //order by name
    villagesFromCommune.sort((a, b) => (a.name > b.name) ? 1 : -1);
    setFilteredVillages(villagesFromCommune);
  }
  
  function handleChangeCommune(event: any) {
    setCommune(event.target.value);
    filterVillageByCommuneId(event.target.value);
  }

  function handleChangeVillage(event: any) {
    setVillage(event.target.value);
  }

  function handleChangePhoneNumber(event: any) {
    setPhoneNumber(event);
  }

  const transform = data => ({
      ...data,
      village: village,
      phone: '+'+phoneNumber,
      notificationPreferenceIds: isDransgrid() ? [1, 2] : data.notificationPreferenceIds
  });

  const PostCreateToolbar = () => {
    const notify = useNotify();
    const { reset } = useFormContext();

    return (
        <Toolbar>
            <SaveButton
                type="button"
                mutationOptions={{
                    onSuccess: () => {
                        reset();
                        setPhoneNumber('');
                        setVillage('');
                        setCommune('');
                        window.scrollTo(0, 0);
                        notify('ra.notification.created', {
                            type: 'info',
                            messageArgs: { smart_count: 1 },
                        });
                    },
                }}
            />
        </Toolbar>
    );
  };

  return (
    <Create title="createCitizen" {...props} mutationmode="pessimistic" transform={transform}>
      <SimpleForm toolbar={<PostCreateToolbar />}>
        <Grid container style={{ width: '100%' }} spacing={2}>
          <Grid item xs={8} md={4}>
            <TextInput source="email" type={"email"} label="citizenEmail" style={{ width: '100%' }} />
          </Grid>
          <Grid item xs={8} md={4}>
            <PhoneInput onChange={handleChangePhoneNumber} value={phoneNumber} label={t("citizenPhone")} required style={{ width: '100%' }} />
          </Grid>
          <Grid item xs={8} md={4}>
            <TextInput source="firstName" label="citizenFirstName" validate={required()} style={{ width: '100%' }} />
          </Grid>
          <Grid item xs={8} md={4}>
            <TextInput source="lastName" label="citizenLastName" validate={required()} style={{ width: '100%' }} />
          </Grid>
          <Grid item xs={8} md={4}>
            <TextInput source="address" label="citizenAddress" style={{ width: '100%' }} />
          </Grid>

          {
            isLiddes() ? <></> :
            <Grid item xs={8} md={4}>
              <FormControl fullWidth required>
                  <InputLabel id="label-commune">Commune</InputLabel>
                  <Select sx={{InputLabelRoot:"#d32f2f"}} id="commune" name="commune" labelId="commune" value={commune} style={{width: '100%'}} onChange={handleChangeCommune}>
                      {
                          communes.map((commune) => {
                              return (<MenuItem value={commune.id} key={commune.id}>{commune.name}</MenuItem>)
                          })
                      }
                  </Select>
              </FormControl>
            </Grid>
          }
          <Grid item xs={8} md={4}>
            <FormControl fullWidth required>
              <InputLabel id="label-village">Village</InputLabel>
              <Select labelId="village" value={village} style={{width: '100%'}} onChange={handleChangeVillage} label="Village">
                  {
                      filteredVillages.map((village) => {
                          return (<MenuItem value={village.id} key={village.id} disabled={village.disabled}>{village.name}</MenuItem>)
                      })
                  }
              </Select>
          </FormControl>
          </Grid>
          {
            isDransgrid() ? <></> :
            <Grid item xs={8} md={4}>
              <ReferenceArrayInput
                reference="notification_types"
                source="notificationPreferenceIds"
                classes={{ root: s.fullWidth }}
              >
                <AutocompleteArrayInput
                    optionText={(type: any) => type && type.label}
                    optionValue="id"
                    label="citizenNotificationPreferences"
                />
              </ReferenceArrayInput>
            </Grid>
          }

          
          {isLoading || !checkBuildingManagement(permissions==undefined?[]:permissions) ? <></> :
            <Grid item xs={8} md={4}>
              <ReferenceInput
                  reference="actors"
                  source="actorId"
                  resettable
              >
                <AutocompleteInput
                    source="owner"
                    optionText={(owner: any) => {
                      if(owner?.id != null){ return owner? owner.firstName + " " + owner.lastName + " " + owner.noActor : "" ;}
                      else{return "";}
                    }}
                    optionValue="id"
                    label={"actor"}
                    filterToQuery={(search) => ({ name: search })}
                />
              </ReferenceInput>
            </Grid>
          }

          <Grid item xs={8} md={4}>
            <BooleanInput source="forceSameNumber" label="forceSameNumber" />
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
}
